"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconOne = void 0;
const env_1 = require("../../conf/env");
const base_api_1 = require("./base-api");
/**
 * @description api services for FalconOne endpoints
 *
 * @export
 * @class FalconOne
 * @extends {BaseApi<T>}
 * @template T
 */
class FalconOne extends base_api_1.BaseApi {
    /**
     *Creates an instance of FalconOne.
     * @param {*} authorizationToken
     * @param {*} domainPermissionToken
     * @memberof FalconOne
     */
    constructor(authorizationToken, domainPermissionToken = false) {
        const axiosConfig = {
            baseURL: env_1.FALCON_ONE_API,
            headers: {
                Authorization: `Bearer ${authorizationToken}`,
                "X-Gloow-Domain-Data": domainPermissionToken
            },
            timeout: 21000
        };
        super(axiosConfig);
    }
    /**
     * @description performs a post with a generic query in Query Basic Language and returns a
     *
     * @template R
     * @param {string} urlSuffix: endpoint name on FalconOne.
     * @param {{ [key: string]: any }} query : Query Language Basics, @see https://sailsjs.com/documentation/concepts/models-and-orm/query-language
     * @returns {Promise<R[]>}, where R is of the same type as the initiated FalconOne Service, for example @interface iNode .
     * @memberof Falconone
     */
    postSearchQuery(urlSuffix, query) {
        return this.post(urlSuffix, query);
    }
    /**
     * @description basic get with optional url parameters.
     *
     * @template R
     * @param {string} urlSuffix
     * @param {{ [key: string]: any }} [httpParams] most likly be a basic key value pair object, i.e. { "name" : "foo"} . For advanced queries, use @method postSearchQuery .
     * @returns {Promise<R[]>}
     * @memberof Falconone
     */
    getSearchQuery(urlSuffix, httpParams) {
        return this.getAll(urlSuffix, httpParams);
    }
    uploadFile(urlSuffix, body, onUploadProgress) {
        return this.post(urlSuffix, body, { onUploadProgress });
    }
}
exports.FalconOne = FalconOne;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmFsY29ub25lLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3ByaXZhdGUvYXBpLXNlcnZpY2VzL2ZhbGNvbm9uZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSx3Q0FBZ0Q7QUFFaEQseUNBQXFDO0FBRXJDOzs7Ozs7O0dBT0c7QUFDSCxNQUFhLFNBQWEsU0FBUSxrQkFBVTtJQUUxQzs7Ozs7T0FLRztJQUNILFlBQVksa0JBQWtCLEVBQUUsd0JBQTBDLEtBQUs7UUFDN0UsTUFBTSxXQUFXLEdBQXVCO1lBQ3RDLE9BQU8sRUFBRSxvQkFBYztZQUN2QixPQUFPLEVBQUU7Z0JBQ1AsYUFBYSxFQUFFLFVBQVUsa0JBQWtCLEVBQUU7Z0JBQzdDLHFCQUFxQixFQUFFLHFCQUFxQjthQUM3QztZQUNELE9BQU8sRUFBRSxLQUFLO1NBQ2YsQ0FBQztRQUVGLEtBQUssQ0FBQyxXQUFXLENBQUMsQ0FBQztJQUNyQixDQUFDO0lBRUQ7Ozs7Ozs7O09BUUc7SUFDSSxlQUFlLENBQVEsU0FBaUIsRUFBRSxLQUFhO1FBQzVELE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBTSxTQUFTLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDMUMsQ0FBQztJQUVEOzs7Ozs7OztPQVFHO0lBQ0ksY0FBYyxDQUFRLFNBQWlCLEVBQUUsVUFBbUI7UUFDakUsT0FBTyxJQUFJLENBQUMsTUFBTSxDQUFJLFNBQVMsRUFBRSxVQUFVLENBQUMsQ0FBQztJQUMvQyxDQUFDO0lBRU0sVUFBVSxDQUNmLFNBQWlCLEVBQ2pCLElBQVksRUFDWixnQkFBd0Q7UUFFeEQsT0FBTyxJQUFJLENBQUMsSUFBSSxDQUFJLFNBQVMsRUFBRSxJQUFJLEVBQUUsRUFBRSxnQkFBZ0IsRUFBRSxDQUFDLENBQUM7SUFDN0QsQ0FBQztDQUNGO0FBdERELDhCQXNEQyJ9